import React from 'react';

// Loading em CSS puro (sem MUI). Mesma API: <LoadingUI message="..." />.
const LoadingUI = ({ message = 'Carregando...' }) => {
  return (
    <div style={S.wrap}>
      <div style={S.spinner} />
      <p style={S.msg}>{message}</p>
      <style>{`@keyframes lui-spin{to{transform:rotate(360deg)}}`}</style>
    </div>
  );
};

const S = {
  wrap: {
    display: 'flex', flexDirection: 'column',
    alignItems: 'center', justifyContent: 'center',
    height: '100vh', gap: 16,
    fontFamily: "'Inter', sans-serif",
  },
  spinner: {
    width: 44, height: 44, borderRadius: '50%',
    border: '4px solid #ece9c8',
    borderTopColor: '#d2d122',
    animation: 'lui-spin 0.8s linear infinite',
  },
  msg: { margin: 0, fontSize: 15, color: '#5b5410', fontWeight: 600 },
};

export default LoadingUI;
